export default __webpack_public_path__ + "static/media/Tanzania.4b2c91ee.svg";